var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import { translate } from '@utils/i18n';
import { ConfirmDialog, showSuccessToast } from '@ui';
import { deficienciesPath } from '@routes';
import useDeleteDeficiency from '../../../hooks/useDeleteDeficiency';
const namespace = 'features.deficiencies.delete_modal';
function DeleteModal({ deficiencyId, toggleDialog, redirectPath = deficienciesPath({}), onDeleted }) {
    const { mutateAsync: deleteDeficiency, isLoading } = useDeleteDeficiency();
    const handleConfirm = () => __awaiter(this, void 0, void 0, function* () {
        yield deleteDeficiency({ id: deficiencyId });
        toggleDialog();
        showSuccessToast('Deficiency deleted successfully');
        onDeleted === null || onDeleted === void 0 ? void 0 : onDeleted();
        if (redirectPath) {
            window.location.href = redirectPath;
        }
    });
    return (React.createElement(ConfirmDialog, { isOpen: true, title: translate('title', { namespace, id: deficiencyId }), description: translate('confirm_delete', { namespace, id: deficiencyId }), confirmLabel: translate('delete', { namespace: 'generic' }), cancelLabel: translate('cancel', { namespace: 'generic' }), confirmVariant: "danger", loading: isLoading, onConfirm: () => {
            void handleConfirm();
        }, onCancel: toggleDialog }));
}
export default DeleteModal;
